module.exports = __webpack_public_path__ + "img/2023102702.f23dfcfa.webp";